import { render } from "./AssignVolume.vue?vue&type=template&id=332c2e30&scoped=true"
import script from "./AssignVolume.vue?vue&type=script&lang=js"
export * from "./AssignVolume.vue?vue&type=script&lang=js"

import "./AssignVolume.vue?vue&type=style&index=0&id=332c2e30&scoped=true&lang=scss"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332c2e30"]])

export default __exports__